import { Frequency } from '@galaxy/billing';
import { UnitBillingFrequency } from '@vendasta/marketplace-apps';
import { Frequency as GalaxyFrequency } from '@vendasta/galaxy/frequency';

export function frequencyForDisplay(f: Frequency): string {
  switch (f) {
    case Frequency.Invalid:
      return '';
    case Frequency.Monthly:
      return 'Monthly';
    case Frequency.OneTime:
      return 'One Time';
    case Frequency.Yearly:
      return 'Yearly';
    default:
      return 'N/A';
  }
}

export function frequencyFromDisplay(f: string): Frequency {
  switch (f) {
    case 'Monthly':
      return Frequency.Monthly;
    case 'One Time':
      return Frequency.OneTime;
    case 'Yearly':
      return Frequency.Yearly;
    default:
      return Frequency.Invalid;
  }
}

export function galaxyFrequencyLabelToGalaxyFrequency(f: string): GalaxyFrequency {
  switch (f) {
    case 'month':
    case 'per month':
    case '/mo':
      return GalaxyFrequency.MONTHLY;
    case 'year':
    case 'per year':
    case '/yr':
      return GalaxyFrequency.YEARLY;
    case 'once':
      return GalaxyFrequency.ONE_TIME;
    default:
      throw Error('Invalid frequency');
  }
}

export function billingFrequencyToUnitPriceFrequency(f: Frequency): UnitBillingFrequency {
  switch (f) {
    case Frequency.Monthly:
      return UnitBillingFrequency.UNIT_BILLING_FREQUENCY_MONTHLY;
    case Frequency.Yearly:
      return UnitBillingFrequency.UNIT_BILLING_FREQUENCY_YEARLY;
    case Frequency.OneTime:
      return UnitBillingFrequency.UNIT_BILLING_FREQUENCY_ONETIME;
    default:
      throw Error('Invalid frequency');
  }
}

export function toGalaxyFrequency(f: UnitBillingFrequency): GalaxyFrequency {
  switch (f) {
    case UnitBillingFrequency.UNIT_BILLING_FREQUENCY_MONTHLY:
      return GalaxyFrequency.MONTHLY;
    case UnitBillingFrequency.UNIT_BILLING_FREQUENCY_YEARLY:
      return GalaxyFrequency.YEARLY;
    case UnitBillingFrequency.UNIT_BILLING_FREQUENCY_ONETIME:
      return GalaxyFrequency.ONE_TIME;
    default:
      throw Error('Invalid frequency');
  }
}

const frequencyLabels = new Map([
  [GalaxyFrequency.MONTHLY, 'month'],
  [GalaxyFrequency.YEARLY, 'year'],
  [GalaxyFrequency.ONE_TIME, 'once'],
]);

const frequencyLabelsRecurringVerbose = new Map([
  [GalaxyFrequency.MONTHLY, 'per month'],
  [GalaxyFrequency.YEARLY, 'per year'],
]);

const frequencyLabelsRecurringShort = new Map([
  [GalaxyFrequency.MONTHLY, '/mo'],
  [GalaxyFrequency.YEARLY, '/yr'],
]);

export function labelForGalaxyFrequency(
  frequency: GalaxyFrequency,
  recurring?: boolean,
  short?: boolean,
): string | undefined {
  if (recurring) {
    if (short) {
      return frequencyLabelsRecurringShort.get(frequency);
    } else {
      return frequencyLabelsRecurringVerbose.get(frequency);
    }
  } else {
    return frequencyLabels.get(frequency);
  }
}
